// extracted by mini-css-extract-plugin
export default {"searchBox":"searchBox_searchBox__Fm1Tc","searchIcon":"searchBox_searchIcon__DWyoJ"};